import {
  createDocument,
  getAllData,
  getById,
  updateDocumentByID,
} from "apis/customApiHandler";
import Modal from "components/Modal";
import Spinner from "components/Spinner";
import useDebounce from "hooks/useDebounce";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import getFormattedDate, {
  convertToIndianTimezoneAndGetDate,
} from "utils/helpers";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import {
  BiCheck,
  BiCloudDownload,
  BiTransferAlt,
  BiMoneyWithdraw,
} from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import { RiCloseFill, RiCloseLine, RiFolderTransferLine } from "react-icons/ri";
import toast from "react-hot-toast";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { useSelector } from "react-redux";
import { Form, FormikProvider, useFormik } from "formik";
import exportExcel from "utils/exportExcel";

const ExternalStockTansferHistory = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [contractType, setContractType] = useState("")
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [transferTyres, setTransferTyres] = useState(null);
  const [acceptData, setAcceptData] = useState(null);
  const [approvedData, setApprovedData] = useState(null);
  const [rejectedData, setRejectedData] = useState(null);
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedFleetsTo, setSelectedFleetsTo] = useState([]);
  const [selectedHubsTo, setSelectedHubsTo] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState("");
  const [request, setRequest] = useState({});
  const [downloading, setDownloading] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [approvalReason, setApprovalReason] = useState(null);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [discountReason, setDiscountReason] = useState(null);
  const [acceptReason, setAcceptReason] = useState(null);
  const navigate = useNavigate();

  const getRequest = async()=>{
    const response = await getById("/tyre/externalStockTransfer", id);
      setRequest(response.data);
  }

  useEffect(() => {
    setId(searchParams.get("_id"));
  }, [searchParams]);

  useEffect(() => {
    if (id) {
      getRequest();
    }
  }, [id]);

  useEffect(() => {
    getData(1, false, true);
  }, []);
  

  
  useEffect(() => {
    //console.log({selectedHubs, selectedHubsTo})
    if (selectedHubsTo?.length || selectedHubs?.length)
      getData(page, false, false);
  }, [page]);
  
  const limit = 20;
  
  const debouncedValue = useDebounce(search, 1000);
  
  
  const { data: allFleets } = useQuery([`/customer-fleet`, debouncedValue], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  console.log(allFleets)
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const { data: allFleetsTo } = useQuery([`/customer-fleet-to`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      fromUsers: 1,
    })
  );
  const { data: allHubsTo } = useQuery([`/customer-hub-to`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      ignoreAssignedHubs: 1,
      fromUsers: 1,
    })
  );

  const getData = async (
    pg,
    download = false,
    fetchIncomingRequests = false
  ) => {
    if (
      !fetchIncomingRequests &&
      !(selectedHubs?.length || selectedHubsTo?.length || search)
    ) {
      return;
    }
    if(download) {setDownloading(true)}
    else setLoading(true);
    try {
      const response = await createDocument("/tyre/externalStockTansfers", {
        searchQuery: search,
        ...(selectedFleets?.includes("all")
          ? {
              fromFleet: getFleetOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fromFleet: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              fromHub: getHubOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              fromHub: selectedHubs.map((hub) => hub).join(","),
            }),

        ...(selectedFleetsTo?.includes("all")
          ? {
              toFleet: getFleetOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedFleetsTo.length && {
              toFleet: selectedFleetsTo.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubsTo?.includes("all")
          ? {
              toHub: getToHubOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubsTo.length && {
              toHub: selectedHubsTo.map((hub) => hub).join(","),
            }),
        dateFrom,
        dateTo,
        page: pg ? pg : page,
        // download: 0,
        ...(type !== "" && { type }),
        ...(contractType !== "" && { contractType }),
        ...(status !== "" && { status }),
        limit: limit,
        download,
        fetchIncomingRequests,
      });
      console.log("responseeeeeee",response)

      if (download && response?.data) {
        console.log("response.data",response.data)
        
        const reportName =  type ? type === "INTERNAL" ? "internal-stock-transfers" 
        : "external-stock-transfers" :"external-stock-transfers"
  
  
        exportExcel(
          response.data.map((entry) => ({
            Date: convertToIndianTimezoneAndGetDate(entry.createdAt),
            "From Fleet": `${entry.fromFleet} (${entry.fromFleetCity ?? "-"})`,
            "From Hub": entry.fromHub,
            "To Fleet": `${entry.toFleet} (${entry.toFleetCity ?? "-"})`,
            "To Hub": entry.toHub,
            Reason: entry.reason,
            Status: entry.status,
            "No of Tyres": 
            // entry.type === "INTERNAL" ? entry.stencilNumbers?.length : 
            entry.tyres?.length ?? entry?.stencilDetails?.length,
            "Created By": entry.updatedBy,
          })),
         reportName
        );
      }
      // setDownloadData(response.data)
      console.log({download})
      if(!download) setData(response);
    } catch (err) {
      console.log("error",err)
    } finally {
      if(download){ setDownloading(false)}
        else setLoading(false);
        }
  };

  const getFleetOptions = useCallback(() => {
    console.log('getting fleet options', allFleets)
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
            KAMs: fleet.KAMs
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all")
          ? allHubs?.data?.length &&
            allHubs?.data?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })
          : allHubs?.data?.length &&
            allHubs?.data
              ?.filter((hub) => {
                const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                );

                return selectedFleetsVal?.some(
                  (fleet) => fleet.fleetCode === hub.fleetCode
                );
              })
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getToFleetOptions = useCallback(() => {
    console.log("in to fleet", allFleetsTo)
    if (allFleetsTo && allFleetsTo.data && allFleetsTo.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleetsTo?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleetsTo]);

  const getToHubOptions = useCallback(() => {
    if (allHubsTo && allHubsTo.data && allHubsTo.data.length) {
      return [
        selectedFleetsTo?.length && {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...(selectedFleetsTo?.includes("all")
          ? allHubsTo?.data?.length &&
            allHubsTo?.data?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })
          : allHubsTo?.data?.length &&
            allHubsTo?.data
              ?.filter((hub) => {
                const selectedFleetsVal = allFleetsTo?.data?.filter((fleet) =>
                  selectedFleetsTo?.includes(fleet._id)
                );

                return selectedFleetsVal?.some(
                  (fleet) => fleet.fleetCode === hub.fleetCode
                );
              })
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              })),
      ];
    }
  }, [allHubsTo, allFleetsTo, selectedFleetsTo]);


  const updateRecord = async (id, status, data = {}) => {
    console.log(id, status, data)
    const myPromise = updateDocumentByID("/tyre/externalStockTransfer", id, {
      status: status,
      ...(data && { ...data }),
    });

    toast.promise(myPromise, {
      loading: "Updating your request",
      success: (dt) => {
        //console.log(dt)
        setTransferTyres(null);
        if (search || selectedHubs?.length || selectedHubsTo?.length) getData();
        return dt.message;
      },
      error: (err) =>
        err?.response?.data.error ||
        err?.response?.data.message ||
        err?.message ||
        "Something went wrong",
    });

    setTransferTyres(null);
  };

  const performTransfer = async (id, type="EXTERNAL", values) => {
    try {
      console.log(values)
      const myPromise = createDocument("/tyre/stockTransfer", {
        id,
        type: type,
        ...values,
        status: "TRANSFERED",
      });

      toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
          //console.log(dt)
          setTransferTyres(null);
          navigate("/stock-transfer");
          if (selectedHubs?.length || selectedHubsTo?.length) getData();
          else getData(1, false, true)
          return `Successful`;
        },
        error: (err) =>
          err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          "Something went wrong",
      });
    } catch (err) {
      //console.log(err)
    }
  };



  console.log("Typpe", data.type === "INTERNAL" , 
    getFleetOptions()?.find(
        (fleet) =>
          fleet.value?.toString() ===
          request.toFleet?._id?.toString()
      )
      ?.KAMs?.includes(currentUser?._id)
    )



  return id ? (
    <>
      <div
        style={{ color: "black" }}
        className="justify-center items-center sm:w-full md:w-3/4 mx-auto text-center mt-10 font-medium text-gray-400 border border-gray-200 border-1 p-2  h-[100%] flex flex-col gap-auto"
      >
        <div className="mb-2">
          {" "}
          Please find the details of stock transfer of{" "}
          {request.tyres?.length ?? request.stencilNumbers?.length} tyre(s) from{" "}
          {request.fromHub?.hubName} to {request.toHub?.hubName} for following
          reason: {request.reason}
        </div>
        <br />
        <div className="w-full h-full overflow-x-auto sm:-mx-6 lg:-mx-8">
          <table className="divide-y divide-gray-200 align-center justify-center mx-auto border border-gray-200 border-1 h-full overflow-x-scroll">
            <thead className="bg-gray-50">
              <tr>
                <TH>Stencil Number</TH>
                <TH>Materials</TH>
                <TH>Size</TH>
                <TH>Orignial NSD</TH>
                <TH>NSD</TH>
                <TH>Tyre Life</TH>
                <TH>Amount</TH>
                <TH>After Discount</TH>
                <TH>RUN KM</TH>
              </tr>
            </thead>
            {request?.tyres?.map((item) => {
              const NDP = parseFloat(
                parseFloat(item.NDPTyre ?? 0) +
                  parseFloat(item.NDPTube ?? 0) +
                  parseFloat(item.NDPFlap ?? 0)
              ).toFixed(2);
              const amount = parseFloat(
                (NDP / item.originalNSD) * (item.averageNSD ?? item.originalNSD)
              ).toFixed(2);
              return (
                <tr>
                  <td className="border border-r-1 text-left px-2">
                    {item?.stencilNo}
                  </td>
                  <td className="border border-r-1 text-left px-2">
                    {item?.productName}
                  </td>
                  <td className="border border-r-1 text-left px-2">
                    {item?.tyreSize}
                  </td>
                  <td className="border border-r-1 text-left px-2 text-right">
                    {parseFloat(item?.originalNSD).toFixed(2)}
                  </td>
                  <td className="border border-r-1 text-left px-2 text-right">
                    {parseFloat(item?.averageNSD).toFixed(2)}
                  </td>
                  <td className="border border-r-1 text-left px-2">
                    {item?.tyreType ?? "ITM"}
                  </td>
                  <td className="border border-r-1 text-left px-2 text-right">
                    {amount ? parseFloat(amount).toFixed(2) : "---"}
                  </td>
                  <td className="border border-r-1 text-left px-2 text-right">
                    {item.afterDiscount
                      ? parseFloat(item.afterDiscount).toFixed(2)
                      : "---"}
                  </td>
                  <td className="border border-r-1 text-left px-2 text-right">
                    {item?.totalKillometerTravelled}
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
        <br />
        <div
          className="w-full flex flex-col"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          {request.status === "REQUESTED" ||
          request.status === "TO BE ACCEPTED" ? (
            <>
              {searchParams.get("action") === "APPROVE" &&
              request.status !== "TO BE ACCEPTED" ?
              ((request.type === "INTERNAL" &&
                getFleetOptions()
                  .find(
                    (fleet) =>
                      fleet.value?.toString() ===
                      request.toFleet._id?.toString()
                  )
                  ?.KAMs?.includes(currentUser?._id)) ||
                (request.type === "EXTERNAL" &&
                  checkPermission(
                    [permissions.approve_external_stock_transfer],
                    currentUser
                  ))) ? (
                <div className="flex flex-col w-full md:w-2/4 my-5">
                  <textarea
                    className={` w-full rounded-md py-2 px-3 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
                    type="text"
                    maxLength={150}
                    placeholder="Enter remarks for approval (max 150 chars)"
                    onChange={(e) => {
                      setApprovalReason(e.target.value);
                    }}
                  />
                  <Button
                    disabled={!approvalReason?.length}
                    onClick={async () => {
                      request.type === "INTERNAL"
                        ? performTransfer(searchParams.get("_id"), "INTERNAL", {
                            tyres: request.tyres,
                            stencilNumbers: request.stencilNumbers,
                            fromHub: request.fromHub._id,
                            toHub: request.toHub._id,
                            fromFleet: request.fromFleet._id,
                            toFleet: request.toFleet._id,
                            contractType: request.contractType,
                            transferReason: approvalReason,
                            transferedBy: currentUser?._id,
                            transferedAt: new Date(
                              new Date() - 330 * 60 * 1000
                            ),
                          })
                        : await updateRecord(
                            searchParams.get("_id"),
                            "APPROVED",
                            {
                              approvalReason,
                              approvedBy: currentUser?._id,
                              approvedAt: new Date(
                                new Date() - 330 * 60 * 1000
                              ),
                            }
                          );
                      navigate("/stock-transfer");
                    }}
                    style={{
                      background: !approvalReason?.length ? "#A3A3A3" : "green",
                      padding: "7px",
                      margin: "7px auto",
                      borderRadius: "4px",
                      width: "10rem",
                    }}
                    className={`${"text-white"}`}
                  >
                    {request.type === "INTERNAL" ? "Transfer " : "Approve "}
                  </Button>
                </div>
              ) : (
                <>
                  You do not have sufficient permissions to approve this request
                </>
              )
            : <></>}
              {searchParams.get("action") === "REJECT" &&
              request.status !== "TO BE ACCEPTED" ?
              ((request.type === "INTERNAL" &&
                getFleetOptions()
                  .find(
                    (fleet) =>
                      fleet.value?.toString() ===
                      request.toFleet._id?.toString()
                  )
                  ?.KAMs?.includes(currentUser?._id)) ||
                (request.type === "EXTERNAL" &&
                  checkPermission(
                    [permissions.approve_external_stock_transfer],
                    currentUser
                  ))) ? (
                <div className="flex flex-col w-full md:w-2/4 my-5">
                  <textarea
                    className={` w-full rounded-md py-2 px-3 text-gray-500  focus:outline-You do not havene focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
                    type="text"
                    maxLength={150}
                    placeholder="Enter remarks (max 150 chars) for rejection"
                    onChange={(e) => {
                      setRejectionReason(e.target.value);
                    }}
                  />
                  <button
                    disabled={!rejectionReason?.length}
                    onClick={async () => {
                      await updateRecord(searchParams.get("_id"), "REJECTED", {
                        rejectionReason,
                        rejectedBy: currentUser?._id,
                        rejectedAt: new Date(new Date() - 330 * 60 * 1000),
                      });
                      navigate("/stock-transfer");
                    }}
                    style={{
                      background: !rejectionReason?.length ? "#A3A3A3" : "red",
                      padding: "7px",
                      margin: "7px auto",
                      width: "10rem",
                      borderRadius: "4px",
                    }}
                    className={`${"text-white"}`}
                  >
                    {" "}
                    Reject{" "}
                  </button>
                </div>
              ) : (
                <>No sufficient permissions to reject this request</>
              )
            : <></>}
              {searchParams.get("action") === "ACCEPT" && (
                <>
                  <div className="flex flex-col w-full md:w-2/4 my-5">
                    <textarea
                      className={` w-full rounded-md py-2 px-3 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
                      type="text"
                      maxLength={150}
                      placeholder="Enter remarks (max 150 chars)"
                      onChange={(e) => {
                        setAcceptReason(e.target.value);
                      }}
                    />
                  </div>
                  <button
                    disabled={!acceptReason?.length}
                    onClick={async () => {
                      await performTransfer(searchParams.get("_id"), "TRANSFERRED", {
                        transferReason: acceptReason,
                        transferedBy: currentUser?._id,
                        transferedAt: new Date(new Date() - 330 * 60 * 1000),
                        ...request,
                      });
                      navigate("/stock-transfer");
                    }}
                    style={{
                      background: !acceptReason?.length ? "#A3A3A3" : "green",
                      padding: "7px",
                      margin: "7px auto",
                      borderRadius: "4px",
                      width: "10rem",
                    }}
                    className={`${"text-white"}`}
                  >
                    {" "}
                    Accept Transfer{" "}
                  </button>
                </>
              )}
            </>
          ) : (
            <>Request is {request.status}</>
          )}
        </div>
      </div>
    </>
  ) : (
    <div className="flex flex-col">
      <div className="mx-10 my-2 flex-row md:flex-col">
        <div className="w-full block">
          <div className="float-right">
            <Button
              type="button"
              bgPrimary
              onClick={async () => {
                // setPage(1);
                // await getData();
                window.location.href = "/create-stock-transfer-request";
              }}
              disabled={
                // (selectedHubs.length === 0 && selectedHubsTo.length === 0) &&
                // !search
                !(
                  checkPermission([permissions.stock_transfer], currentUser) ||
                  checkPermission(
                    [permissions.external_stock_transfer],
                    currentUser
                  )
                )
              }
            >
              Create Stock Transfer
            </Button>
          </div>
        </div>

        <div className="mt-8 flex flex-row justify-start gap-6 items-start w-full">
          <div className=" w-full md:w-1/2 flex-col">
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-start items-end gap-y-5 gap-x-2">
              <label className="w-full py-3 flex flex-col gap-2">
                Type
                <Select
                  name="type"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setStatus("");
                  }}
                >
                  <option value={""}>All</option>
                  <option value={"INTERNAL"}>Internal</option>
                  <option value={"EXTERNAL"}>External</option>
                </Select>
              </label>
              <label className="w-full py-3 flex flex-col gap-2">
                Status
                <Select
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value={""}>All</option>
                  <option value={"REQUESTED"}>Requested</option>
                  <option value={"APPROVED"}>Approved</option>
                  <option value={"REJECTED"}>Rejected</option>
                  <option value={"TO BE ACCEPTED"}>To be accepted</option>
                  <option value={"TRANSFERED"}>Transferred</option>
                </Select>
              </label>
              <label className="w-full py-3 flex flex-col gap-2">
                Contract Type
                <Select
                  name="type"
                  value={contractType}
                  onChange={(e) => {
                    setContractType(e.target.value);
                  }}
                >
                  <option value={""}>All</option>
                  <option value={"CPKM"}>CPKM</option>
                  <option value={"NON CPKM"}>Non CPKM</option>
                </Select>
              </label>
            </div>

            <div className="w-full grid grid-cols-1 md:grid-cols-3 justify-start items-end gap-y-5 gap-x-2">
              <label className="w-full py-3 flex flex-col gap-2">
                Search By Stencil Number
                <Input
                  type="search"
                  placeholder="Search Here"
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </label>

              <label className="w-full py-3 flex flex-col gap-2">
                Start Date{" "}
                <Input
                  type="date"
                  max={getFormattedDate()}
                  name="dateFrom"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </label>
              <label className="w-full py-3 flex flex-col gap-2">
                End Date{" "}
                <Input
                  type="date"
                  min={getFormattedDate(dateFrom)}
                  name="dateTo"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </label>
            </div>
          </div>

          <div className="flex flex-col w-full md:w-1/2">
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-start items-end gap-y-5 gap-x-2">
              <label className="w-full py-3 flex flex-col gap-2">
                From Fleet
                <ReactSelect
                  styles={filterSelectStyles}
                  className="shadow-md rounded-md"
                  options={getFleetOptions()}
                  value={
                    selectedFleets &&
                    selectedFleets?.map((fleet) => {
                      return {
                        value: fleet,
                        label: getFleetOptions()?.find(
                          (item) => item?.value === fleet
                        )?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    let allValues = value?.map((item) => item.value);
                    if (allValues?.includes("clear")) {
                      // console.log(allValues)
                      setSelectedFleets([]);
                      setSelectedHubs([]);
                      return;
                    }
                    if (
                      !selectedFleets?.includes("all") &&
                      allValues.includes("all")
                    ) {
                      setSelectedFleets(["all"]);
                      return;
                    }

                    if (selectedFleets.includes("all")) {
                      // console.log("first");
                      // console.log(getFleetOptions())
                      value = value.filter((item) => item.value !== "all");
                    }

                    let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                      value?.map((item) => item.value)?.includes(fleet._id)
                    );

                    let selectedHubsVal = allHubs?.data?.filter((hub) =>
                      selectedHubs?.map((item) => item)?.includes(hub._id)
                    );

                    setSelectedHubs(
                      selectedHubsVal
                        ?.filter((hub) =>
                          selectedFleetsVal?.find(
                            (fleet) => fleet.fleetCode === hub.fleetCode
                          )
                        )
                        .map((hub) => hub._id)
                    );

                    // console.log({allHubs, selectedHubs})

                    setSelectedFleets(value.map((fleet) => fleet.value));
                  }}
                  name="fleets"
                  isMulti={true}
                />
              </label>
              <label className="w-full py-3 flex flex-col gap-2">
                From Hub
                <ReactSelect
                  styles={filterSelectStyles}
                  className="shadow-md rounded-md"
                  options={getHubOptions()}
                  value={
                    selectedHubs &&
                    selectedHubs?.map((hub) => {
                      // console.log({hub})
                      return {
                        value: hub,
                        label: getHubOptions()?.find(
                          (item) => item.value === hub
                        )?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    // console.log({allValues})
                    if (allValues.includes("clear")) {
                      setSelectedHubs([]);
                      return;
                    }
                    if (
                      !selectedHubs?.includes("all") &&
                      allValues.includes("all")
                    ) {
                      let selectedFleetCodes = allFleets?.data
                        ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                        ?.map((fleet) => fleet.fleetCode);

                      const selectedHubsData = allHubs?.data?.filter((hub) =>
                        selectedFleetCodes?.includes(hub.fleetCode)
                      );

                      const mp = fleetMap;
                      selectedHubsData.map((hub) => {
                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                          if (mp[hub.fleetCode] === undefined)
                            mp[hub.fleetCode] = [];
                          mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                        }
                      });

                      setFleetMap(mp);
                      setSelectedHubs(["all"]);
                    } else {
                      // console.log({value})
                      value = value.filter((value) => value.value !== "all");
                      // console.log({value})
                      let selectedFleetCodes = allFleets?.data
                        ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                        ?.map((fleet) => fleet.fleetCode);
                      // console.log({allValues})

                      const selectedHubsData = allHubs?.data?.filter((hub) =>
                        allValues?.includes(hub._id)
                      );
                      const mp = {};
                      selectedHubsData.map((hub) => {
                        mp[hub.fleetCode] = [];
                      });

                      selectedHubsData.map((hub) => {
                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                          if (mp[hub.fleetCode] === undefined)
                            mp[hub.fleetCode] = [];
                          mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                        }
                      });

                      setFleetMap(mp);
                      setSelectedHubs(value.map((hub) => hub.value));
                    }
                  }}
                  name="hubs"
                  isMulti={true}
                />
              </label>
            </div>
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-start items-end gap-y-5 gap-x-2">
              <label className="w-full py-3 flex flex-col gap-2">
                To Fleet
                <ReactSelect
                  styles={filterSelectStyles}
                  className="shadow-md rounded-md"
                  options={getToFleetOptions()}
                  value={
                    selectedFleetsTo &&
                    selectedFleetsTo?.map((fleet) => {
                      return {
                        value: fleet,
                        label: getToFleetOptions()?.find(
                          (item) => item?.value === fleet
                        )?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    if (allValues?.includes("clear")) {
                      // console.log(allValues)
                      setSelectedFleetsTo([]);
                      setSelectedHubsTo([]);
                      return;
                    }
                    if (
                      !selectedFleetsTo?.includes("all") &&
                      allValues.includes("all")
                    ) {
                      setSelectedFleetsTo(["all"]);
                      return;
                    }
                    if (selectedFleetsTo.includes("all")) {
                      // console.log("first");
                      // console.log(getFleetOptions())
                      value = value.filter((item) => item.value !== "all");
                    }
                    let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                      value?.map((item) => item.value)?.includes(fleet._id)
                    );

                    let selectedHubsVal = allHubsTo?.data?.filter((hub) =>
                      selectedHubsTo?.map((item) => item)?.includes(hub._id)
                    );

                    setSelectedHubsTo(
                      selectedHubsVal
                        ?.filter((hub) =>
                          selectedFleetsVal?.find(
                            (fleet) => fleet.fleetCode === hub.fleetCode
                          )
                        )
                        .map((hub) => hub._id)
                    );

                    // console.log({allHubs, selectedHubs})

                    setSelectedFleetsTo(value.map((fleet) => fleet.value));
                  }}
                  name="fleets"
                  isMulti={true}
                />
              </label>

              <label className="w-full py-3 flex flex-col gap-2">
                To Hub
                <ReactSelect
                  styles={filterSelectStyles}
                  className="shadow-md rounded-md"
                  options={getToHubOptions()}
                  value={
                    selectedHubsTo &&
                    selectedHubsTo?.map((hub) => {
                      return {
                        value: hub,
                        label: getToHubOptions()?.find(
                          (item) => item.value === hub
                        )?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    // console.log({allValues})
                    if (allValues.includes("clear")) {
                      setSelectedHubsTo([]);
                      return;
                    }
                    if (
                      !selectedHubsTo?.includes("all") &&
                      allValues.includes("all")
                    ) {
                      let selectedFleetCodes = allFleetsTo?.data
                        ?.filter((fleet) =>
                          selectedFleetsTo?.includes(fleet._id)
                        )
                        ?.map((fleet) => fleet.fleetCode);

                      const selectedHubsData = allHubsTo?.data?.filter((hub) =>
                        selectedFleetCodes?.includes(hub.fleetCode)
                      );

                      const mp = fleetMap;
                      selectedHubsData.map((hub) => {
                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                          if (mp[hub.fleetCode] === undefined)
                            mp[hub.fleetCode] = [];
                          mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                        }
                      });

                      setFleetMap(mp);
                      setSelectedHubsTo(["all"]);
                    } else {
                      // console.log({value})
                      value = value.filter((value) => value.value !== "all");
                      // console.log({value})
                      let selectedFleetCodes = allFleetsTo?.data
                        ?.filter((fleet) =>
                          selectedFleetsTo?.includes(fleet._id)
                        )
                        ?.map((fleet) => fleet.fleetCode);
                      // console.log({allValues})

                      const selectedHubsData = allHubsTo?.data?.filter((hub) =>
                        allValues?.includes(hub._id)
                      );
                      const mp = {};
                      selectedHubsData.map((hub) => {
                        mp[hub.fleetCode] = [];
                      });

                      selectedHubsData.map((hub) => {
                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                          if (mp[hub.fleetCode] === undefined)
                            mp[hub.fleetCode] = [];
                          mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                        }
                      });

                      setFleetMap(mp);
                      setSelectedHubsTo(value.map((hub) => hub.value));
                    }
                  }}
                  name="hubs"
                  isMulti={true}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="w-full block mb-3">
          <div className="float-right flex flex-row gap-1">
            <Button
              type="button"
              bgPrimary
              onClick={async () => {
                setPage(1);
                await getData();
              }}
              disabled={
                selectedHubs.length === 0 &&
                selectedHubsTo.length === 0 &&
                !search
              }
            >
              Search
            </Button>
            {downloading
              ? "Downloading..."
              : !(
                  selectedHubs.length === 0 &&
                  selectedHubsTo.length === 0 &&
                  !search
                ) && (
                  <BiCloudDownload
                    className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                    onClick={() => {
                      getData(1, true);
                    }}
                  />
                )}
          </div>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-2">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr className="py-2">
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Created At Time</TH>
                      {/* <TH scope="col">From Fleet</TH> */}
                      <TH scope="col">From Hub</TH>
                      {/* <TH scope="col">To Fleet</TH> */}
                      <TH scope="col">To Hub</TH>
                      <TH scope="col">Number of Tyres</TH>
                      <TH scope="col">Created By</TH>
                      {/* <TH scope="col">Contract Type</TH> */}
                      <TH scope="col">Status</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data?.data &&
                      data.data.map((item, index) => (
                        <ViewList
                          page={page}
                          data={item}
                          key={item?._id}
                          index={index}
                          setModalData={setModalData}
                          getData={getData}
                          updateRecord={updateRecord}
                          setTransferTyres={setTransferTyres}
                          setAcceptData={setAcceptData}
                          setApprovedData={setApprovedData}
                          setRejectedData={setRejectedData}
                          approvalReason={item.approvalReason}
                          rejectionReason={item.rejectionReason}
                          reason={item.reason}
                          currentUser={currentUser}
                          getFleetOptions={getFleetOptions}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {data && data.paginate && data.paginate.total && (
            <div className="container mx-auto flex justify-center items-center gap-2 py-5">
              <Button
                onClick={() => {
                  setPage((p) => Math.max(p - 1, 1));
                }}
                disabled={page === 1}
                className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                primary
              >
                <div className="flex gap-1 items-center">
                  <IoMdArrowBack />
                  Prev Page
                </div>
              </Button>
              <span className="text-gray-600 px-4">{`showing: ${
                (page - 1) * 20 + 1
              } - ${Math.min(data?.paginate?.total, page * 20)} of ${
                data.paginate.total
              }`}</span>

              {data.paginate.total > page * 20 && (
                <Button
                  onClick={() => {
                    //console.log("setting pages")
                    setPage((p) => Math.min(p + 1, data?.paginate?.total));
                  }}
                  disabled={page === data?.paginate?.total}
                  className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                  primary
                >
                  <div className="flex gap-1 items-center">
                    Next Page
                    <IoMdArrowForward />
                  </div>
                </Button>
              )}
            </div>
          )}
        </div>
      )}
      {modalData && (
        <Modal
          handleClick={() => {
            setModalData(null);
          }}
          title="Stock Transfer Info"
        >
          <p className=" text-medium font-semibold bg-gray-100 rounded-md p-2 m-2  text-center">
            {modalData.reason ?? "N/A"}
          </p>

          <div className="overflow-x-scroll">
            <table className="min-w-full divide-y divide-gray-200">
              <TableHeader />
              <tbody className="bg-white divide-y divide-gray-200">
                {modalData &&
                  modalData.tyres?.map((item, index) => (
                    <ViewTyreList
                      data={item}
                      key={item?._id}
                      index={index}
                      setModalData={setModalData}
                    />
                  ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-col m-2 lg:m-2">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr className="py-2">
                        <TH scope="col">Action</TH>
                        <TH scope="col">By</TH>
                        <TH scope="col">On</TH>
                        <TH scope="col">Remarks</TH>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {modalData?.approvedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Approval</TD>
                          <TD>{modalData.approvedBy}</TD>
                          <TD>{modalData.approvedAt}</TD>
                          <TD>{modalData.approvalReason}</TD>
                        </tr>
                      )}
                      {modalData?.rejectedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Reject</TD>
                          <TD>{modalData.rejectedBy}</TD>
                          <TD>{modalData.rejectedAt}</TD>
                          <TD>{modalData.rejectionReason}</TD>
                        </tr>
                      )}
                      {modalData?.discountedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Discount</TD>
                          <TD>{modalData.discountedBy}</TD>
                          <TD>{modalData.discountedAt}</TD>
                          <TD>{modalData.discountReason}</TD>
                        </tr>
                      )}
                      {modalData?.transferedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Accept</TD>
                          <TD>{modalData.transferedBy}</TD>
                          <TD>{modalData.transferedAt}</TD>
                          <TD>{modalData.transferReason}</TD>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* {modalData?.approvedBy && (
            <p className="w-full p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
              <h1 className="font-semibold text-medium p-2 text-left">
                Approval Remarks
              </h1>
              <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                {modalData.approvalReason ?? "N/A"}
              </p>
              <div className="flex flex-row gap-4">
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Approval By
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.approvedBy ?? "N/A"}
                  </p>
                </div>
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Approval On
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.approvedAt ?? "N/A"}
                  </p>
                </div>
              </div>
            </p>
          )}

          {modalData?.rejectedBy && (
            <p className="w-full p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
              <h1 className="font-semibold text-medium p-2 text-left">
                Rejection Remarks
              </h1>
              <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                {modalData.rejectionReason ?? "N/A"}
              </p>
              <div className="flex flex-row gap-4">
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Rejection By
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.rejectedBy ?? "N/A"}
                  </p>
                </div>
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Rejection On
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.rejectedAt ?? "N/A"}
                  </p>
                </div>
              </div>
            </p>
          )}

          {modalData?.discountedBy && (
            <p className="w-full p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
              <h1 className="font-semibold text-medium p-2 text-left">
                Discount Remarks
              </h1>
              <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                {modalData.discountReason ?? "N/A"}
              </p>
              <div className="flex flex-row gap-4">
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Discount By
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.discountedBy ?? "N/A"}
                  </p>
                </div>
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Discount On
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.discountedAt ?? "N/A"}
                  </p>
                </div>
              </div>
            </p>
          )}

          {modalData?.transferedBy && (
            <p className="w-full p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
              <h1 className="font-semibold text-medium p-2 text-left">
                Transfer Remarks
              </h1>
              <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                {modalData.transferReason ?? "N/A"}
              </p>
              <div className="flex flex-row gap-4">
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Transfer By
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.transferedBy ?? "N/A"}
                  </p>
                </div>
                <div className="flex flex-col">
                  <h1 className="font-semibold text-medium p-2 text-left">
                    Transfer On
                  </h1>
                  <p className=" text-medium  rounded-md p-2 w-full  text-center">
                    {modalData.transferedAt ?? "N/A"}
                  </p>
                </div>
              </div>
            </p>
          )} */}
        </Modal>
      )}
      {/* {//console.log({modalData})} */}

      {transferTyres && (
        <Modal
          handleClick={() => {
            setTransferTyres(null);
          }}
          title="Stock Transfer Discount"
        >
          <TransferTyres
            data={transferTyres}
            // key={item?._id}
            // index={index}
            updateRecord={updateRecord}
            setModalData={setModalData}
            performTransfer={performTransfer}
            setDiscountReason={setDiscountReason}
            discountReason={discountReason}
            userId={currentUser?._id}
          />
        </Modal>
      )}
      {acceptData && (
        <Modal
          handleClick={() => {
            setAcceptData(null);
          }}
          title="Stock Transfer Acceptance"
        >
          <div className="p-4">
            <div className="p-4 overflow-x-hidden">
              <p className="font-semibold text-medium bg-gray-100 rounded-md p-2 my-2 text-center">
                {acceptData.reason}
              </p>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <TableHeader />
                  <tbody className="bg-white divide-y divide-gray-200">
                    {acceptData?.tyres?.map((item, index) => (
                      <ViewTyreList data={item} index={index} />
                    ))}
                  </tbody>
                </table>
              </div>

              <textarea
                className={` w-full rounded-md py-2 px-3  my-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
                type="text"
                maxLength={150}
                placeholder="Enter remarks for acceptance (max 150 chars)"
                onChange={(e) => {
                  setAcceptReason(e.target.value);
                }}
              />

              <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
                <Button
                  bgSecondary
                  onClick={() => {
                    setAcceptData(null);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  disabled={!acceptReason?.length}
                  bgPrimary
                  onClick={async () => {
                    await performTransfer(acceptData._id, acceptData.type, {
                      ...acceptData,
                      transferedAt: new Date(new Date() - 330 * 60 * 1000),
                      transferedBy: currentUser?._id,
                      transferReason: acceptReason,
                      status: "TRANSFERED",
                    });
                    setAcceptData(null);
                  }}
                >
                  Accept
                </Button>
              </div>

              <div className="flex flex-col m-2 lg:m-2">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr className="py-2">
                            <TH scope="col">Action</TH>
                            <TH scope="col">By</TH>
                            <TH scope="col">On</TH>
                            <TH scope="col">Remarks</TH>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {acceptData?.approvedBy && (
                            <tr className="bg-gray-100 h-10">
                              <TD>Approval</TD>
                              <TD>{acceptData.approvedBy}</TD>
                              <TD>{acceptData.approvedAt}</TD>
                              <TD>{acceptData.approvalReason}</TD>
                            </tr>
                          )}
                          {acceptData?.discountedBy && (
                            <tr className="bg-gray-100 h-10">
                              <TD>Discount</TD>
                              <TD>{acceptData.discountedBy}</TD>
                              <TD>{acceptData.discountedAt}</TD>
                              <TD>{acceptData.discountReason}</TD>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {/* <p className="p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
                <h1 className="font-semibold text-medium p-2 text-left">
                  Approval Remarks
                </h1>
                <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                  {acceptData.approvalReason ?? "N/A"}
                </p>
                <div className="flex flex-row gap-4">
                  <div className="flex flex-col">
                    <h1 className="font-semibold text-medium p-2 text-left">
                      Approval By
                    </h1>
                    <p className=" text-medium  rounded-md p-2 w-full  text-center">
                      {acceptData.approvedBy ?? "N/A"}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <h1 className="font-semibold text-medium p-2 text-left">
                      Approval On
                    </h1>
                    <p className=" text-medium  rounded-md p-2 w-full  text-center">
                      {acceptData.approvedAt ?? "N/A"}
                    </p>
                  </div>
                </div>
              </p>

              <p className="p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
                <h1 className="font-semibold text-medium p-2 text-left">
                  Discount Remarks
                </h1>
                <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
                  {acceptData.discountReason ?? "N/A"}
                </p>
                <div className="flex flex-row gap-4">
                  <div className="flex flex-col">
                    <h1 className="font-semibold text-medium p-2 text-left">
                      Discount By
                    </h1>
                    <p className=" text-medium  rounded-md p-2 w-full  text-center">
                      {acceptData.discountedBy ?? "N/A"}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <h1 className="font-semibold text-medium p-2 text-left">
                      Discount On
                    </h1>
                    <p className=" text-medium  rounded-md p-2 w-full  text-center">
                      {acceptData.discountedAt ?? "N/A"}
                    </p>
                  </div>
                </div>
              </p> */}
            </div>
          </div>
        </Modal>
      )}
      {approvedData && (
        <Modal
          handleClick={() => {
            setApprovedData(null);
          }}
          title="Stock Transfer Approval"
        >
          <div className="p-4 overflow-x-hidden">
            <p className="font-semibold text-medium bg-gray-100 rounded-md p-2 my-2 text-center">
              {approvedData.reason}
            </p>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <TableHeader />
                <tbody className="bg-white divide-y divide-gray-200">
                  {approvedData?.tyres?.map((item, index) => (
                    <ViewTyreList data={item} index={index} />
                  ))}
                </tbody>
              </table>
            </div>

            {/* <p className="text-green-500 p-5 text-center">
            Plesae enter reason to Approve the transfer request?
            </p> */}

            {console.log({ acceptReason })}

            <textarea
              className={` w-full rounded-md py-2 px-3  my-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
              type="text"
              maxLength={150}
              placeholder="Enter remarks for approval (max 150 chars)"
              onChange={(e) => {
                setApprovalReason(e.target.value);
              }}
            />
          </div>
          <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
            <Button
              bgSecondary
              onClick={() => {
                setApprovedData(null);
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              disabled={!approvalReason?.length}
              bgPrimary
              onClick={async () => {
                //console.log({approvedData})
                if (approvedData.type === "INTERNAL")
                  await performTransfer(approvedData?._id, "INTERNAL", {
                    contractType: approvedData.contractType,
                    _id: approvedData._id,
                    fromHub: approvedData.fromHub,
                    toHub: approvedData.toHub,
                    // tyres: approvedData.stencilDetails?.map((item) => ({
                    //   stencilNo: item.stencilNo,
                    // })),
                    tyres: approvedData.tyres,
                    transferReason: approvalReason,
                    transferedBy: currentUser?._id,
                    transferedAt: new Date(new Date() - 330 * 60 * 1000),
                    status: "TRANSFERED",
                  });
                else
                  await updateRecord(approvedData?._id, "APPROVED", {
                    approvalReason,
                    approvedBy: currentUser?._id,
                    approvedAt: new Date(new Date() - 330 * 60 * 1000),
                  });
                setApprovedData(null);
              }}
            >
              {approvedData.type === "INTERNAL" ? "Transfer" : "Approve"}
            </Button>
          </div>
        </Modal>
      )}
      {rejectedData && (
        <Modal
          handleClick={() => {
            setRejectedData(null);
          }}
          title="Stock Transfer Rejection"
        >
          <div className="p-4 overflow-x-hidden">
            <p className="font-semibold text-medium bg-gray-100 rounded-md p-2 my-2 text-center">
              {rejectedData.reason}
            </p>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <TableHeader />
                <tbody className="bg-white divide-y divide-gray-200">
                  {rejectedData?.tyres?.map((item, index) => (
                    <ViewTyreList data={item} index={index} />
                  ))}
                </tbody>
              </table>
            </div>

            <textarea
              className={` w-full rounded-md py-2 px-3  m-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
              type="text"
              placeholder="rejection Reason"
              onChange={(e) => {
                setRejectionReason(e.target.value);
              }}
            />
          </div>
          <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
            <Button
              bgSecondary
              onClick={() => {
                setRejectedData(null);
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              bgPrimary
              onClick={async () => {
                //console.log({rejectedData})
                await updateRecord(rejectedData?._id, "REJECTED", {
                  rejectionReason,
                  rejectedAt: new Date(new Date() - 330 * 60 * 1000),
                  rejectedBy: currentUser?._id,
                });
                setRejectedData(null);
              }}
            >
              Reject
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ExternalStockTansferHistory;

const ViewTyreList = ({ data, index }) => {
  const NDP = parseFloat(
    parseFloat(data.NDPTyre ?? 0) +
      parseFloat(data.NDPTube ?? 0) +
      parseFloat(data.NDPFlap ?? 0)
  ).toFixed(2);
  const amount = parseFloat(
    (NDP / data.originalNSD) * (data.averageNSD ?? data.originalNSD)
  ).toFixed(2);
  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}>
      <TD>{index + 1}</TD>
      <TD>{data.stencilNo}</TD>
      <TD>{data.productName}</TD>
      <TD>{data.tyreSize}</TD>
      <TD>
        {" "}
        <div className="text-right">{data.originalNSD}</div>
      </TD>
      <TD>
        <div className="text-right">{data.averageNSD}</div>
      </TD>
      <TD>{data.tyreType ?? "ITM"}</TD>
      <TD>
        <div className="text-right">
          {data.NDPTyre ? parseFloat(data.NDPTyre).toFixed(2) : "---"}
        </div>
      </TD>
      <TD>
        <div className="text-right">
          {data.NDPTube ? parseFloat(data.NDPTube).toFixed(2) : "---"}
        </div>
      </TD>
      <TD>
        <div className="text-right">
          {data.NDPFlap ? parseFloat(data.NDPFlap).toFixed(2) : "---"}
        </div>
      </TD>
      <TD>
        <div className="text-right">
          {data.amount ? parseFloat(data.amount).toFixed(2) : "---"}
        </div>
      </TD>
      <TD>
        <div className="text-right">{data.discount ?? "---"}</div>
      </TD>
      <TD>
        <div className="text-right">{data.afterDiscount ?? "---"}</div>
      </TD>
    </tr>
  );
};

const TableHeader = () => {
  return (
    <thead className="bg-gray-50">
      <tr className="py-2">
        <TH scope="col">S.N.</TH>
        <TH scope="col">Stencil Number</TH>
        <TH scope="col">Materials</TH>
        <TH scope="col">Size</TH>
        <TH scope="col">Original NSD</TH>
        <TH scope="col">NSD</TH>
        <TH scope="col">Tyre Life</TH>
        <TH scope="col">NDP Tyre</TH>
        <TH scope="col">NDP Tube</TH>
        <TH scope="col">NDP Flap</TH>
        <TH scope="col">Amount</TH>
        <TH scope="col">Discount (%)</TH>
        <TH scope="col">After Discount</TH>
      </tr>
    </thead>
  );
};

const TransferTyres = ({
  data,
  index,
  setModalData,
  performTransfer,
  updateRecord,
  setDiscountReason,
  discountReason, 
  userId
}) => {
  // const [discount]
  const [values, setValues] = useState([]);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    //console.log({data})
    const tmp = data?.tyres?.map((item) => {
      return { ...item, amount: 0, discount: 0 };
    });
    setValues([...tmp]);
    formik.setValues({ tyres: [...tmp] });
  }, [data]);

  const formik = useFormik({
    initialValues: {
      tyres: values,
    },
    onSubmit: async (values) => {
      try {
        //console.log(values.tyres)
        // performTransfer(data._id, {...data, tyres: values.tyres})
        updateRecord(data._id, "TO BE ACCEPTED", { tyres: values.tyres });
      } catch (error) {
        //console.log({error})
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Something went wrong"
        );
      }
    },

    validate: (values) => {
      let errors = {
        tyres: [
          ...values?.tyres?.map((tyre) => {
            return { discount: "", afterDiscount: "" };
          }),
        ],
      };

      values.tyres.map((tyre, index) => {
        //console.log(tyre.discount)
        if (parseInt(tyre.discount) > 99) {
          errors.tyres[index].discount = "Please enter value < 100";
          errors.tyres[index].afterDiscount = "cannot be -ve";
        } else {
          delete errors.tyres[index];
        }
      });
      if (!errors.tyres[0]) {
        errors.tyres = null;
      }
      //console.log({errors, values})
      setDisabled(errors?.tyres);
      return errors;
    },
  });

  // useEffect(()=>{
  // },[disabled])

  return (
    <FormikProvider value={formik}>
      <p className="font-semibold text-medium bg-gray-100 rounded-md p-2 my-2 text-center">
                {data.reason}
              </p>
      <Form className="m-2">
        <div className="w-full overflow-x-scroll">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr className="py-2">
              <TH scope="col">S.N.</TH>
              <TH scope="col">Stencil Number</TH>
              <TH scope="col">Materials</TH>
              <TH scope="col">Size</TH>
              <TH scope="col">Original NSD</TH>
              <TH scope="col">NSD</TH>
              <TH scope="col">Tyre Life</TH>
              <TH scope="col">NDP Tyre</TH>
              <TH scope="col">NDP Tube</TH>
              <TH scope="col">NDP Flap</TH>
              <TH scope="col">Amount</TH>
              <TH scope="col">Discount (%)</TH>
              <TH scope="col">After Discount</TH>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {formik.values &&
              formik.values?.tyres?.map((data, index) => {
                const NDP = parseFloat(
                  parseFloat(data.NDPTyre ?? 0) +
                    parseFloat(data.NDPTube ?? 0) +
                    parseFloat(data.NDPFlap ?? 0)
                ).toFixed(2);
                const amount = parseFloat(
                  (NDP / data.originalNSD) *
                    (data.averageNSD ?? data.originalNSD)
                ).toFixed(2);
                return (
                  <tr
                    key={data._id}
                    className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}
                  >
                    <TD>{index + 1}</TD>
                    <TD>{data.stencilNo}</TD>
                    <TD>{data.productName}</TD>
                    <TD>{data.tyreSize}</TD>
                    <TD>
                      {" "}
                      <div className="text-right">{data.originalNSD}</div>
                    </TD>
                    <TD>
                      <div className="text-right">{data.averageNSD}</div>
                    </TD>
                    <TD>{data.tyreType ?? "ITM"}</TD>
                    <TD>
                      <div className="text-right">
                        {data.NDPTyre
                          ? parseFloat(data.NDPTyre).toFixed(2)
                          : "---"}
                      </div>
                    </TD>
                    <TD>
                      <div className="text-right">
                        {data.NDPTube
                          ? parseFloat(data.NDPTube).toFixed(2)
                          : "---"}
                      </div>
                    </TD>
                    <TD>
                      <div className="text-right">
                        {data.NDPFlap
                          ? parseFloat(data.NDPFlap).toFixed(2)
                          : "---"}
                      </div>
                    </TD>
                    <TD>
                      <div className="text-right">{amount ?? "---"}</div>
                    </TD>

                    <TD>
                      <Input
                        type="number"
                        formik={formik}
                        value={formik.values.tyres[index]?.discount}
                        name={`tyres[${index}].discount`}
                        dissabled={!(data.originalNSD || data.averageNSD)}
                        max={"100"}
                        min={"0"}
                        className="w-10"
                        onChange={(e) => {
                          const discount = e.target.value;
                          if (e.target.value >= 100) {
                            return;
                          }
                          const afterDiscount = parseFloat(
                            (1 - 0.01 * discount) * amount
                          ).toFixed(2);
                          formik.setFieldValue(
                            `tyres[${index}].discount`,
                            e.target.value
                          );
                          formik.setFieldValue(
                            `tyres[${index}].afterDiscount`,
                            afterDiscount
                          );
                          formik.setFieldValue(
                            `tyres[${index}].amount`,
                            amount
                          );
                          // setValues(temp)
                        }}
                      ></Input>

                      <p className="text-red-500 flex">
                        {formik.errors?.tyres?.length &&
                        formik.errors.tyres[index]?.discount
                          ? formik.errors.tyres[index]?.discount + "*"
                          : ""}
                      </p>
                    </TD>
                    <TD>
                      {data.afterDiscount}
                      <p className="text-red-500 flex">
                        {formik.errors?.tyres?.length &&
                        formik.errors.tyres[index]?.afterDiscount
                          ? formik.errors.tyres[index]?.afterDiscount + "*"
                          : ""}
                      </p>
                    </TD>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <textarea
          className={` w-full rounded-md py-2 px-3  my-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
          type="text"
          maxLength={150}
          placeholder="Enter remarks for discount (max 150 chars)"
          onChange={(e) => {
            setDiscountReason(e.target.value);
          }}
        />

        <div className="flex justify-end">
          <Button
            disabled={disabled || !discountReason}
            primary
            className="mt-4 mx-2 py-2 h-12 justify-end float-right mr-0"
            onClick={async () => {
              try {
                // performTransfer(data._id, {...data, tyres: formik.values.tyres})
                updateRecord(data._id, "TO BE ACCEPTED", {
                  tyres: formik.values.tyres,
                  discountReason: discountReason,
                  discountedBy: userId,
                  discountedAt: new Date(new Date() - (330 * 60 * 1000)),
                });
                setDiscountReason(null);
              } catch (err) {
                toast.message("error", err?.message);
              }
            }}
          >
            {" "}
            Submit{" "}
          </Button>
        </div>

        <div className="flex flex-col m-2 lg:m-2">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr className="py-2">
                      <TH scope="col">Action</TH>
                      <TH scope="col">By</TH>
                      <TH scope="col">On</TH>
                      <TH scope="col">Remarks</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data?.approvedBy && (
                    <tr className="bg-gray-100 h-10">
                    <TD>Approve</TD>
                    <TD>{data.approvedBy}</TD>
                    <TD>{data.approvedAt}</TD>
                    <TD>{data.approvalReason}</TD>
                    </tr>                       
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* <p className="w-full p-2 flex flex-col items-center justify-center mx-auto border rounded-sm mt-2">
          <h1 className="font-semibold text-medium p-2 text-left">
            Approval Remarks
          </h1>
          <p className=" text-medium bg-gray-100 rounded-md p-2 w-full md:w-2/3 text-center">
            {data.approvalReason ?? "N/A"}
          </p>
          <div className="flex flex-row gap-4">
            <div className="flex flex-col">
              <h1 className="font-semibold text-medium p-2 text-left">
                Approval By
              </h1>
              <p className=" text-medium  rounded-md p-2 w-full  text-center">
                {data.approvedBy ?? "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <h1 className="font-semibold text-medium p-2 text-left">
                Approval On
              </h1>
              <p className=" text-medium  rounded-md p-2 w-full  text-center">
                {data.approvedAt ?? "N/A"}
              </p>
            </div>
          </div>
        </p> */}
        </div>
      </Form>
    </FormikProvider>
  );
};

const ViewList = ({
  data,
  index,
  setModalData,
  setTransferTyres,
  updateRecord,
  currentUser,
  setAcceptData,
  setApprovedData,
  setRejectedData,
  page,
  ...props
}) => {
  const getStencilDetails =  (stencilDetails)=>{
    return stencilDetails.map(item => ( {
      "stencilNo": item.stencilNo,
      "productName": item.productInfo?.productName ?? item.productMasterInfo?.productName,
      "brand": item.productInfo?.tyrePattern ?? item.productMaster?.productName,
      "materialNo": item.productInfo?.materialNo ?? item.productMasterInfo?.materialNo,
      "originalNSD": item.productInfo?.originalNSD ?? item.productMasterInfo?.originalNSD,
      "tyreSize": item.productInfo?.tyreSize ?? item.productMasterInfo?.tyreSize,
      "totalKillometerTravelled": item.totalKillometerTravelled,
      "averageNSD": item.averageNSD,
      "NDPTyre": null,
      "NDPTube": null,
      "NDPFlap": null,
      "amount": item.productInfo?.NDPTyre + item.productInfo?.NDPTube + item.productInfo?.NDPFlap,
      "discount": "N/A",
      "afterDiscount": "N/A",
  }))
  }
  const getDiv = (type, status) => {
    return (
      <div
        className={`${
          status
            ? status === "REQUESTED"
              ? "text-gray-600"
              : status === "REJECTED"
              ? "text-red-600"
              : status === "APPROVED"
              ? "text-blue-500"
              : status === "TO BE ACCEPTED"
              ? "text-orange-400"
              : "text-green-500"
            : "text-green-500"
        } font-medium `}
      >
        {" "}
        {!status ? "TRANSFERRED" : status === 'TRANSFERED' ? "TRANSFERRED" : status}{" "}
      </div>
    );
  };

  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}>
      <TD>{(page - 1) * 20 + index + 1}</TD>
      <TD>{convertToIndianTimezoneAndGetDate(data.createdAt, true)}</TD>
      {/* <TD>{data.fromFleet}</TD> */}
      <TD>{data.fromHub}</TD>
      {/* <TD>{data.toFleet}</TD> */}
      <TD>{data.toHub}</TD>
      <TD className="stock-transfers-stencil-numbers text-green-500 hover:text-green-600 cursor-pointer text-center font-semibold flex">
        <div
          className="bg-green-100 rounded-md font-semibold p-1 px-2"
          onClick={() => {
            let tyres = [];
            //console.log({dt}, data)

            // if(data.type == "INTERNAL"){
            //   tyres = getStencilDetails(data.stencilDetails)
            // }
            // else
            tyres = data.tyres?.length
              ? data?.tyres
              : getStencilDetails(data.stencilDetails);

            console.log(data);
            setModalData({ ...data, tyres });
          }}
        >
          {data.tyres?.length || data.stencilDetails?.length}
        </div>
      </TD>
      <TD>{data.updatedBy && data.updatedBy ? data.updatedBy : "---"}</TD>
      {/* <TD>{data.contractType}</TD> */}
      <TD>{getDiv(data.type, data.status)}</TD>
      <TD className="flex flex-row gap-1">
        {data.status === "REQUESTED" &&
        ((data.type === "EXTERNAL" &&
          checkPermission(
            [permissions.approve_external_stock_transfer],
            currentUser
          )) ||
          (
            data.type === "INTERNAL" &&
            props
              .getFleetOptions?.()
              ?.find((fleet) => fleet.value?.toString() === data.toFleetId?.toString())
          ?.KAMs?.includes(currentUser?._id))) ? (
          <button
            className="p-1 px-2 m-1 bg-green-500 hover:bg-green-600 shadow-none font-bold rounded-md text-white text-md"
            onClick={() => {
              // updateRecord(data._id, "APPROVED")
              // if(data.type === "INTERNAL")
              //   data.tyres = getStencilDetails(data.stencilDetails)
              setApprovedData(data);
            }}
          >
            <FaCheck />
          </button>
        ) : (
          <></>
        )}
        {data.status == "APPROVED" &&
        checkPermission(
          [permissions.external_stock_transfer_discount],
          currentUser
        ) ? (
          <button
            className="p-1 px-3 m-1 bg-cyan-500 hover:bg-cyan-600 shadow-none font-bold rounded-md text-white text-md"
            onClick={() => {
              setTransferTyres(data);
            }}
          >
            %D
          </button>
        ) : (
          <></>
        )}
        {data.status === "REQUESTED" && ( 
          (data.type === "EXTERNAL" &&
          checkPermission(
            [permissions.approve_external_stock_transfer],
            currentUser
          )) ||
          (
            data.type === "INTERNAL" &&
            props
              .getFleetOptions?.()
              ?.find((fleet) => { return fleet.value?.toString() === data.toFleetId?.toString()})
          ?.KAMs?.includes(currentUser?._id))) ? (
          <button
            className="p-1 px-2 m-1 bg-red-500 hover:bg-red-600 shadow-none font-bold rounded-md text-white text-lg"
            onClick={() => {
              if (data.type === "INTERNAL")
                data.tyres = getStencilDetails(data.stencilDetails);
              setRejectedData(data);
              // setApprovedList(data.tyres)
            }}
          >
            <RiCloseLine />
          </button>
        ) : (
          <></>
        )}
        {data.status == "TO BE ACCEPTED" &&
        checkPermission([permissions.stock_transfer], currentUser) ? (
          <button
            className="p-1 px-2 m-1 bg-orange-400 hover:bg-orange-500 shadow-none font-bold rounded-md text-white text-lg"
            onClick={() => {
              console.log(data);
              setAcceptData(data);
              // setApprovedList(data.tyres)
            }}
          >
            <RiFolderTransferLine />
          </button>
        ) : (
          <></>
        )}
      </TD>
    </tr>
  );
};